import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBedrijf = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M31 18v16H9V18zm-2-8v5H11v-5z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M18 26v8h-5v-8zm9 0v5h-5v-5zm5-11v3a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 0 1-5.995.176L8 18v-3z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M29.5 12.5H16v-1h14.5V18h-1zm-14 8.159A3 3 0 0 1 10 19h1a2 2 0 1 0 4 0h1a2 2 0 1 0 4 0h1a3 3 0 0 1-5.5 1.659A3 3 0 0 1 10 19h1a2 2 0 1 0 4 0h1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBedrijf);

export default ForwardRef;
